module.exports = __webpack_public_path__ + "img/ledgendborn.105be4a1.png";